import React, { useMemo } from 'react';
import { BaseComponentProps } from '../types';

import { ICustomerDetails } from '../types/customer';
import useData, { UpdateDataFunction } from '../hooks/utility/useData';

export type CustomerDetailsContext = {
  customerData: null | ICustomerDetails;
  updateCustomerData: UpdateDataFunction<ICustomerDetails>;
  setCustomerData: (value: null | ICustomerDetails) => void;
};

export const CustomerDetailsContext = React.createContext<CustomerDetailsContext>(null);

export default function CustomerDetailsProvider({ children }: BaseComponentProps) {
  const { data, updateData, setData } = useData<ICustomerDetails>(null);

  const context = useMemo(
    () => ({
      customerData: data,
      updateCustomerData: updateData,
      setCustomerData: setData,
    }),
    [data],
  );

  return (
    <CustomerDetailsContext.Provider value={context}>{children}</CustomerDetailsContext.Provider>
  );
}
